import styled from 'styled-components';
import space from '../utils/style/space';

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${space.m}px;
`;

export default InputContainer;
